import * as Sentry from "@sentry/gatsby"

Sentry.init({
  dsn:
    "https://9261cf86a9b3413da348da1f9747950d@o385035.ingest.sentry.io/4505188520558592",
  sampleRate: 0.7,
  environment: process.env.NODE_ENV,
  enabled: process.env.NODE_ENV === "production",
})
